export default function WhatWontWorkSection() {
  const items = [
    "Trying to walk into a passport agency — Appointment-only. No walk-ins. Appointments book 2–4 weeks out in 2026.",
    "Relying on the post office to expedite — Post offices submit applications but cannot speed up processing or jump the queue.",
    "Using an online government renewal for speed — The State Dept's online renewal is routine service only. It cannot be expedited.",
    "Waiting to see if your current application moves faster — If you have an application in process and it's not moving, call us immediately at 877-253-0084. We may be able to help.",
    "Going through a retail counter like FedEx or Staples — They're resellers. You pay their markup and they hand it to a registered courier like us anyway. Come directly to us and save 20–80%.",
  ];

  return (
    <section className="py-14 md:py-20 bg-amber-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D2D2D] mb-4">
            Common Mistakes That Waste Time in an Urgent Passport Situation
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {items.map((item, i) => (
            <div key={i} className="flex items-start gap-4 bg-white rounded-lg border border-amber-200 p-5">
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                <i className="ri-close-circle-fill text-red-500 text-xl"></i>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed pt-1">{item}</p>
            </div>
          ))}

          <div className="mt-8 text-center">
            <a
              href="tel:8772530084"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 bg-[#2D2D2D] hover:bg-[#1a1a1a] text-white font-bold rounded-md transition-colors cursor-pointer"
            >
              <i className="ri-phone-fill text-xl"></i>
              Call 877-253-0084 — Don't Waste Time
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}